module.exports = __webpack_public_path__ + "static/media/santander-bank.8959fca7.svg";